<template>
  <div class="">
    <van-nav-bar
      title="找回密码"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <!-- 短信 -->
    <div class="input">
      <input
        class="password"
        placeholder="请输入手机号"
        v-model="mobile"
         @change="get"
      >
      <div class="hr"></div>
      <div class="down">
        <input
          class="password"
          placeholder="请输入图形验证码"
          v-model="checkcode"
        >
        <div class="eyes1">
          <img @click="get" style="width: 3rem;" :src="cimg" alt="">
        </div>
        <div class="hr"></div>

      </div>
      <div class="down">
        <input
          class="password"
          placeholder="请输入验证码"
          v-model="check"
        >
        <div class="eyes1">
          <van-button
            type="primary"
            size="mini"
            @click="timego"
            :disabled="but"
          >{{timetxt}}</van-button>
        </div>
        <div class="hr"></div>

      </div>
      <input
        class="password"
        v-model="newpas"
        placeholder="请输入新密码"
      >
      <div class="hr"></div>
      <input
        class="password"
        v-model="newpass"
        placeholder="确认新密码"
      >
      <div class="hr"></div>

    </div>

    <div class="longon">
      <van-button
        type="primary"
        size="large"
        @click="xiu"
      >确认修改</van-button>
    </div>

  </div>
</template>
<script>
import Vue from 'vue';
import { NavBar, Field, Button, Toast } from 'vant';
Vue.use(NavBar).use(Field).use(Button);
export default {
  created () {
  },
  data () {
    return {
      newpas: '',
      newpass: '',
      password: '',
      mobile: '',
      check: '',
      eysshow: true,
      txt1: true,
      timefalg: true,
      time: 60,
      timetxt: "发送验证码",
      but: false,
      checkcode: '',
      cimg:''
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    onClickRight () {
      this.$router.push('/logon')
    },
    goretrieve () {
      this.$router.push('/retrieve')
    },
    back () {
      this.eysshow = !this.eysshow
      if (this.$refs.input.type === 'text') {
        this.$refs.input.type = 'password'
      } else {
        this.$refs.input.type = 'text'
      }
    },
    changelogin () {
      this.txt1 = !this.txt1
    },
    timego () {
      if (this.mobile.trim()) {
        if (/^1[23456789]\d{9}$/.test(this.mobile)) {
        } else {
          Toast('请输入正确手机号')
          return
        }
      } else {
        Toast('请输入手机号')
        return
      }
      if (this.checkcode) { } else { 
        Toast('请输入图形验证码')
        return

      }
      this.axios.post("forgetPassword", { mobile: this.mobile }).then(res => {
        if (res.data.code == 200) {
          this.axios.post("sendnewsmscode", { mobile: this.mobile ,source:'hkjforgotpwd',checkcode:this.checkcode}).then(res => {
            if (res.data.code == 200) {
              Toast('发送成功')
            this.but = true
            var timer = setInterval(() => {
              this.time--
              this.timetxt = '请' + this.time + '秒后发送'
              if (this.time === 0) {
                this.but = false
                clearInterval(timer)
                this.time = 60
                this.timetxt = '发送验证码'
              }
            }, 1000)
            }else {
              Toast(res.data.msg)
              this.get()
            }
           
          }).catch(ref => {
            console.log(ref)
          })
        } else {
          Toast('该手机号未注册')
        }
      }).catch(ref => { })
    },
    xiu () {
      if (this.newpass.trim().length < 6) {
        Toast('新密码输入请大于5位')
        return
      }
      if (this.newpas == this.newpass) {
        this.axios.post("forgetPasswordSendVertify", { mobile: this.mobile, check: this.check, password: this.newpass }).then(res => {
        
          if (res.data.code == 200) {
            Toast(res.data.msg)
            this.$router.push('login')
          }else {
            Toast(res.data.msg)
          }
        }).catch(ref => {
          console.log(ref)
        })
      } else {
        Toast('新密码输入请一致')
      }
    },
    get () {
      this.axios.post("creimgcode", {source:'hkjforgotpwd',phone:this.mobile  }).then(res => {
      // console.log(res)
      this.cimg=res.data.data.base64_image 

    }).catch(ref => {
      console.log(ref)
    })
    }
  }
}
</script>
<style lang="less" scoped>
.input {
  padding-left: 10%;
  background-color: #fff;
  padding-top: 1rem;
}
.password {
  width: 90%;
  height: 1.25rem;
  border: none;
  font-size: 0.4rem;
  padding-left: 0.3rem;
}
.hr {
  width: 90%;
  height: 1px;
  background-color: #c3c3c3;
}
.down {
  position: relative;
}

.eyes1 {
  position: absolute;
  right: 10%;
  top: 50%;
  transform: translateY(-50%);
}
.message {
  padding-top: 0.65rem;
  text-align: right;
  padding-right: 10%;
}
.longon {
  padding-top: 0.65rem;
  width: 80%;
  margin: 0 auto;
}
</style>